export const GUSTAFTA_BASE_URL = 'https://gustafta.my.id';

export const GUSTAFTA_LINKS = [
  {
    id: 'sbu',
    icon: '✅',
    title: 'Cek Kesiapan SBU',
    desc: 'Persiapan legalitas yang mendukung verifikasi LPJK dan SBU.',
    path: '/cek-kesiapan-sbu',
    supports: 'Verifikasi LPJK & SBU',
  },
  {
    id: 'documents',
    icon: '📄',
    title: 'Bedah Dokumen',
    desc: 'Ringkas dokumen tender dan temukan risiko atau tindak lanjut penting.',
    path: '/bedah-dokumen',
    supports: 'Documents & Bidding',
  },
  {
    id: 'clinic',
    icon: '🧠',
    title: 'Klinika AI',
    desc: 'Bawa pertanyaan teknis, regulasi, dan operasional ke ruang konsultasi.',
    path: '/klinik-konsultasi',
    supports: 'AI Assistant & Knowledge',
  },
  {
    id: 'tender',
    icon: '⚖️',
    title: 'Peluang Tender',
    desc: 'Baca peluang tender dengan konteks sebelum menyiapkan penawaran.',
    path: '/tender',
    supports: 'Marketplace & Bidding',
  },
  {
    id: 'brain-project',
    icon: '🔮',
    title: 'Brain Project',
    desc: 'Gunakan konteks pengetahuan dan dokumen untuk membantu supervisi proyek.',
    path: '/brain-project',
    supports: 'Project Manager & Analytics',
  },
  {
    id: 'project',
    icon: '📊',
    title: 'Ruang Proyek',
    desc: 'Hubungkan dokumen, keputusan, dan perkembangan pekerjaan per proyek.',
    path: '/ruang-proyek',
    supports: 'Proyek Saya & Site Control',
  },
];

export const getGustaftaUrl = (path) => `${GUSTAFTA_BASE_URL}${path}`;